import Box from "@mui/material/Box";
import {
  AlertTitle,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Grid,
  OutlinedInput,
  ListItemText,
  Avatar,
  Typography,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ListIcon from "@mui/icons-material/List";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { green } from "@mui/material/colors";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import { validarSenha } from "../../Components/Funcionais/Utils";
import { PostAPI } from "../../Components/Backend/PostAPI";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { PutAPI } from "../../Components/Backend/PutAPI";
import { validarEmail } from "../../Components/Funcionais/Utils";
import APIAxios from "../../Api/APIAxios";
import PageTitle from "../../components/Layout/PageTitle";
import SessaoAuth from "../../Hooks/SessaoAuth";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function UserRegistration() {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(2); //Controle de Acessos
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */
  //***************************************   SALVAR e SALVAR + NOVO ********************************* */
  const [modoIncluirMais, setModoIncluirMais] = useState(false);
  //************************************************************************************************** */

  const navigate = useNavigate();
  const apiAxios = APIAxios();

  const [perfis, setPerfis] = useState([]);
  const [perfisSelecionados, setPerfisSelecionados] = useState([]);
  const [emailError, setEmailError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [senhaValida, setSenhaValida] = useState(false);
  const [confSenha, setConfSenha] = useState("");
  const MAX_SIZE = 2 * 1024 * 1024; // 2MB

  const [formData, setFormData] = useState({
    id: 0,
    nome: "",
    cargo: "",
    email: "",
    senha: "",
    status: "A",
    idEmpresa: 0,
    idPerfil: 0,
    tipo: "A",
  });

  const [avatarFile, setAvatarFile] = useState(null);

  // Este estado guarda a URL temporária para exibir a imagem na tela
  const [previewUrl, setPreviewUrl] = useState(null);

  //Busca Perfil no backend
  const buscaPerfis = async () => {
    setLoading(true);
    const response = await GetAPI(apiAxios, "/perfis");

    setLoading(false);

    if (response.success) {
      setPerfis(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  useEffect(() => {
    buscaPerfis();
  }, []);

  const carregarAvatar = async (id) => {
    //Carrega identificação das imagens
    const response = await GetAPI(apiAxios, "/usuario/avatar/" + id, {
      responseType: "blob",
    });

    // Cria uma URL temporária para o blob recebido
    const blobUrl = URL.createObjectURL(response.data);

    setFormData((prev) => ({
      ...prev,
      avatarUrl: blobUrl,
    }));
  };

  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;
    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    if (typeof value === "string") {
      if (name === "email") {
        valor = valor.toLowerCase();
      } else {
        if (name !== "senha") {
          valor = valor.toUpperCase();
        }
      }
    }

    //Converte o texto para maiusculo
    setFormData((prevData) => ({
      ...prevData,
      [name]: valor,
    }));
  };

  const handleVoltar = () => {
    navigate("/usuarios");
  };

  const handleValidarSenha = (event) => {
    const { name, value } = event.target;

    if (value && value.length > 0 && !validarSenha(value)) {
      setAvisoErro("Senha muito fraca.");
      setSenhaValida(false);
    } else {
      setSenhaValida(true);
    }
  };

  const handleValidarEmail = (event) => {
    const { name, value } = event.target;

    if (!validarEmail(value)) {
      setAvisoErro("E-mail inválido");
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };

  useEffect(() => {
    if (
      formData.senha &&
      formData.senha.length > 0 &&
      !validarSenha(formData.senha)
    ) {
      setSenhaValida(false);
    } else {
      setSenhaValida(true);
    }
  }, [formData.senha]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setAvisoSucesso("");
    setAvisoErro("");
    setLoading(true);

    if (formData.senha || confSenha.length > 0) {
      if (formData.senha !== confSenha) {
        setAvisoErro("A senha e a confirmação de senha não coincidem.");
        return;
      }
    }

    if (formData.senha && formData.senha.length > 0) {
      //Validar senha
      if (!validarSenha(formData.senha)) {
        setAvisoErro("Senha muito fraca.");
        return;
      }
    }

    //Validar email
    if (!validarEmail(formData.email)) {
      setAvisoErro("E-mail inválido.");
      setEmailError(true);
      return;
    }

    const registro = {
      id: formData.id,
      nome: formData.nome,
      cargo: formData.cargo,
      email: formData.email,
      senha: formData.senha,
      status: formData.status,
      idEmpresa: formData.idEmpresa,
      tipo: formData.tipo,
      idPerfil: (formData.idPerfil =
        perfisSelecionados.length > 0 ? perfisSelecionados[0] : null),
    };

    const response = await PostAPI(apiAxios, "/usuario", registro);
    setLoading(false);
    if (response.success) {
      setAvisoSucesso("Usuário salvo com sucesso.");

      if (avatarFile) {
        try {
          await uploadAvatar(avatarFile, response.data.id);
        } catch (err) {
          setAvisoErro("Falha ao enviar imagem.");
        }
      }

      if (modoIncluirMais) {
        limparCampos();
      } else {
        setFormData(response.data);
        carregarAvatar(response.data.id);

        await new Promise((resolve) => setTimeout(resolve, 3000));
        navigate("/usuarios");
      }
    } else {
      setAvisoErro(response.errorMessage || "Erro ao salvar usuário.");
    }
  };

  const limparCampos = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    setPreviewUrl(null);
    setAvatarFile(null);

    setFormData({
      cargo: "",
      email: "",
      senha: "",
      id: 0,
      idEmpresa: 0,
      idPerfil: 0,
      nome: "",
      status: "",
      tipo: "A",
      avatarUrl: null,
    });
    setConfSenha("");
    setPerfisSelecionados([]);
  };

  const uploadAvatar = async (file, userId) => {
    const fd = new FormData();
    fd.append("file", file);

    const resp = await apiAxios.post(`/usuario/avatar/${userId}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return resp.data;
  };

  // Função para processar a nova imagem selecionada
  const handleImageChange = async (e) => {
    setAvisoErro("");
    setAvisoSucesso("");

    const file = e.target.files?.[0];
    if (!file) return;

    // valida tamanho
    if (file.size > MAX_SIZE) {
      setAvisoErro("Imagem maior que 2MB.");
      return;
    }

    // valida extensão (backend aceita apenas .png ou .jpg)
    const allowedExt = ["png", "jpg", "jpeg"];
    const ext = file.name.split(".").pop()?.toLowerCase();
    if (!ext || !allowedExt.includes(ext)) {
      setAvisoErro("Arquivo deve ser PNG ou JPG.");
      return;
    }

    // valida mime-type (mais confiável que só extensão)
    const allowedMime = ["image/png", "image/jpeg"];
    if (!allowedMime.includes(file.type)) {
      setAvisoErro("Tipo de arquivo inválido. Use PNG ou JPG.");
      return;
    }

    // limpa preview antigo
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    setAvatarFile(file);

    // preview local imediato
    const url = URL.createObjectURL(file);

    setPreviewUrl(url);
    setFormData((prev) => ({ ...prev, avatarUrl: url }));
  };

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Cadastro de Gestor"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box sx={{ flexGrow: 1, p: 3, overflow: "visible" }}>
        <form onSubmit={handleSubmit}>
          {/* Grid Container Principal que divide a tela em duas colunas */}
          <Grid container spacing={4} alignItems="stretch">
            {/* --- COLUNA DA ESQUERDA: AVATAR --- */}
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderRight: { md: "1px solid #e0e0e0" }, // Linha divisória lateral
                pr: { md: 4 },
                textAlign: "center",
              }}
            >
              <Avatar
                src={previewUrl || formData.avatarUrl}
                sx={{
                  width: 160,
                  height: 160,
                  mb: 2,
                  border: "1px solid #ccc",
                }}
              />

              <Button
                variant="outlined"
                component="label"
                startIcon={
                  <AttachFileIcon sx={{ transform: "rotate(45deg)" }} />
                } // Ícone de clipe inclinado
                sx={{
                  mb: 1,
                  textTransform: "none",
                  width: "100%",
                  borderColor: "#1a3865",
                  color: "#1a3865",
                }}
              >
                Atualizar imagem
                <input
                  type="file"
                  hidden
                  accept="image/png,image/jpeg"
                  onChange={handleImageChange}
                />
              </Button>

              {/*<Button
                variant="text"
                color="inherit"
                onClick={handleRemoveImage}
                sx={{ textTransform: 'none', color: '#666', fontSize: '0.875rem' }}
              >
                Remover
              </Button>*/}

              <Typography variant="caption" color="textSecondary">
                PNG/JPG - até 2MB
              </Typography>
            </Grid>

            {/* --- COLUNA DA DIREITA --- */}
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>
                {/*Nome*/}
                <Grid item xs={12} md={12}>
                  <TextField
                    label="Nome do Gestor(a)"
                    name="nome"
                    type="text"
                    value={formData.nome}
                    onChange={(e) => handleChange(e, 50)}
                    required
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/*Cargo*/}
                <Grid item xs={12} md={12}>
                  <TextField
                    label="Cargo do Gestor(a)"
                    name="cargo"
                    type="text"
                    value={formData.cargo}
                    onChange={(e) => handleChange(e, 50)}
                    required
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={(e) => handleChange(e, 50)}
                    onBlur={(e) => handleValidarEmail(e)}
                    required
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Senha"
                    name="senha"
                    type={showPassword ? "text" : "password"}
                    onChange={handleChange}
                    value={formData.senha}
                    required
                    fullWidth
                    onBlur={(e) => handleValidarSenha(e)}
                    error={formData.senha && senhaValida === false}
                    helperText={
                      formData.senha && senhaValida === false
                        ? "Senha inválida! Deve ter de 8 a 64 caracteres, sem espaços, com maiúscula, minúscula, número e 1 caracter especial (@#$.*)."
                        : " "
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          sx={{
                            width: "12%",
                            display: "flex",
                            justifyContent: "space-around",
                          }}
                        >
                          <IconButton
                            onClick={togglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>

                          {formData.senha ? (
                            senhaValida === true ? (
                              <CheckCircleIcon
                                color="success"
                                fontSize="small"
                                style={{ marginLeft: "8px" }}
                              />
                            ) : (
                              <CancelRoundedIcon
                                color="error"
                                fontSize="small"
                                style={{ marginLeft: "8px" }}
                              />
                            )
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                    autoComplete="new-password"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Confirmação de Senha"
                    name="Confsenha"
                    value={confSenha}
                    type={showConfirmPassword ? "text" : "password"}
                    onChange={(ev) => setConfSenha(ev.target.value)}
                    required
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          sx={{
                            width: "12%",
                            display: "flex",
                            justifyContent: "space-around",
                          }}
                        >
                          <IconButton
                            onClick={toggleConfirmPasswordVisibility}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                          {confSenha && formData.senha ? (
                            confSenha === formData.senha ? (
                              <CheckCircleIcon
                                color="success"
                                fontSize="small"
                                style={{ marginLeft: "8px" }}
                              />
                            ) : (
                              <CancelRoundedIcon
                                color="error"
                                fontSize="small"
                                style={{ marginLeft: "8px" }}
                              />
                            )
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                    autoComplete="new-password"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="label-status">Situação</InputLabel>
                    <Select
                      labelId="label-status"
                      label="Situação"
                      name="status"
                      value={formData.status}
                      onChange={(e) => {
                        handleChange(e, 1);
                      }}
                    >
                      <MenuItem value="A">Ativo</MenuItem>
                      <MenuItem value="I">Inativo</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="label-status">Perfil</InputLabel>
                    <Select
                      labelId="label-perfil"
                      required
                      label="Função"
                      name="perfil"
                      value={perfisSelecionados}
                      onChange={(e) => {
                        const v = e.target.value;
                        setPerfisSelecionados(
                          (Array.isArray(v) ? v : [v]).map(Number),
                        );
                      }}
                      input={<OutlinedInput label="Perfis" />}
                      renderValue={(selected) =>
                        selected
                          .map((id) => perfis.find((p) => p.id === id)?.nome)
                          .filter(Boolean)
                      }
                    >
                      {perfis.map((profile) => (
                        <MenuItem key={profile.id} value={profile.id}>
                          {perfisSelecionados.includes(profile.id)}
                          <ListItemText primary={profile.nome} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between", // separa esquerda e direita
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 2,
                    mt: 2,
                  }}
                >
                  <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{ backgroundColor: "#1a3865", width: "100%" }}
                      onClick={handleVoltar}
                    >
                      Voltar
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      width: { xs: "100%", md: "auto" },
                      flexDirection: { xs: "column", md: "row" },
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="large"
                      type="submit"
                      onClick={() => setModoIncluirMais(true)}
                      sx={{
                        borderColor: "#1a3865",
                        color: "#1a3865",
                      }}
                    >
                      Salvar + Incluir
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      type="submit"
                      onClick={() => setModoIncluirMais(false)}
                      sx={{
                        backgroundColor: "#1a3865",
                      }}
                    >
                      Salvar
                    </Button>
                  </Box>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
}
